import { render } from "./PatientCard.vue?vue&type=template&id=5310797f&scoped=true"
import script from "./PatientCard.vue?vue&type=script&lang=js"
export * from "./PatientCard.vue?vue&type=script&lang=js"

import "./PatientCard.vue?vue&type=style&index=0&id=5310797f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5310797f"]])

export default __exports__